import SEOHead from '@/components/SEOHead';
import HomeHeroV2 from '@/components/marketing/home/v2/HomeHeroV2';
import BeforeAfterSection from '@/components/marketing/home/v2/BeforeAfterSection';
import HomeFeaturePillarsV2 from '@/components/marketing/home/v2/HomeFeaturePillarsV2';
import TestimonialsWithMetricsV2 from '@/components/marketing/home/v2/TestimonialsWithMetricsV2';
import TrustStripV2 from '@/components/marketing/home/v2/TrustStripV2';
import HomeFaqV2 from '@/components/marketing/home/v2/HomeFaqV2';
import { FinalCtaSection } from '@/components/marketing/v2/FinalCtaSection';
import { useFaqItems } from '@/hooks/useFaqItems';
import { ORGANIZATION_JSONLD, SOFTWARE_APP_JSONLD } from '@/lib/seo';

const BASE_JSON_LD: Record<string, unknown>[] = [ORGANIZATION_JSONLD, SOFTWARE_APP_JSONLD];

export default function Home() {
  const faqItems = useFaqItems();

  const jsonLd: Record<string, unknown>[] = [...BASE_JSON_LD];
  if (faqItems.length > 0) {
    jsonLd.push({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqItems.map(({ q, a }) => ({
        '@type': 'Question',
        name: q,
        acceptedAnswer: { '@type': 'Answer', text: a },
      })),
    });
  }

  return (
    <>
      <SEOHead
        title="Velko POS — Logiciel de caisse et point de vente pour l'Afrique"
        description="Logiciel de caisse conçu pour les commerçants africains. Gestion des ventes, stocks et paiements Mobile Money, même hors ligne. Essai gratuit au Cameroun, Sénégal, Côte d'Ivoire."
        path="/"
        ogImage="/brand/og/og-home.png"
        jsonLd={jsonLd}
        breadcrumbs={[{ name: 'Accueil', path: '/' }]}
      />

      <HomeHeroV2 />
      <TrustStripV2 />
      <BeforeAfterSection />
      <HomeFeaturePillarsV2 />
      <TestimonialsWithMetricsV2 />
      <HomeFaqV2 />
      <FinalCtaSection
        eyebrow="Prêt quand tu l'es"
        title="Ta caisse. Prête dans"
        highlight="3 minutes."
        subtitle="Sans carte bancaire. Sans engagement. Sans installation compliquée. Juste toi, Velko, et ton prochain encaissement."
        primaryLabel="Créer mon compte gratuit"
        primaryTo="/register"
        secondaryLabel="Parler à un humain"
        secondaryTo="/contact"
      />
    </>
  );
}
